export enum CheckTools {
  GOOD = 1,
  BAD = 2,
  NONE = 3,
}

export enum StatusConfirm {
  DIRECTED = 2,
  CONFIRMED = 1,
  UNCONFIRMED = 0,
  未確認あり = 0,
  確認済 = 1,
  指導済 = 2,
}

export enum StatusRky {
  NOT_PROVED = 0,
  APPROVED = 1,
}

export enum TypeDates {
  DEFAULT,
  MIN_START,
  MAX_END,
}
